import { IAugmentedJQuery, IController, IDocumentService, IScope } from 'angular';

export abstract class DocumentClickAbstractController implements IController {
  public isActive: boolean;

  constructor( protected $element: IAugmentedJQuery,
               protected $document: IDocumentService,
               protected $scope: IScope ) {
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  $onDestroy() {
    this.clearListeners();
  }

  toggle() {
    this.isActive = !this.isActive;
    if ( this.isActive ) {
      return this.initListeners();
    }
    this.clearListeners();
  }

  protected initListeners() {
    this.$document.on('click', this.onDocumentClick);
  }

  protected clearListeners() {
    this.$document.off('click', this.onDocumentClick);
  }

  private onDocumentClick( event ) {
    if ( this.isActive && this.$element.has(event.target).length === 0 ) {
      this.isActive = false;
      this.clearListeners();
      this.$scope.$digest();
    }
  }
}



// WEBPACK FOOTER //
// ./app/shared/abstract/document-click-abstract.controller.ts